export default "__VITE_ASSET__DODr1ywO__"